import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { conciergeModalities, CONTACT } from '../../data/modalities';
export function ConciergeSuite() {
  return <section id="concierge" className="w-full bg-navy py-20 text-white sm:py-24" data-id="element-160" data-mp="28ez1f84d4vqv">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-161" data-mp="23fvwrosaorjf">
        <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-162" data-mp="1yfq8mil8hn63">
          <div data-id="element-163" data-mp="2w2ynhuqqbxz4">
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal-light" data-id="element-164" data-mp="2w1f78452pmxc">
              CONCIERGE MODALITY SUITE
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight sm:text-[2.4rem]" data-id="element-165" data-mp="2r5q79zp5640i">
              Build the right modality mix around your practice
            </h2>
            <p className="mt-5 text-[16px] leading-relaxed text-white/80" data-id="element-166" data-mp="2hbq4i4hc1auy">
              The Concierge Modality Suite is JAG’s consultative planning process
              for practices considering more than one technology. Start with
              patient needs, current services, staff workflow, space, and growth
              goals, then compare which modalities belong together and which
              should wait.
            </p>
            <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-167" data-mp="4pz9h091xxjb">
              <PhoneIcon className="h-[18px] w-[18px]" data-id="element-168" data-mp="3vte7wur9rlfv" />
              Call About the Suite
            </a>
          </div>
          <div className="relative grid grid-cols-2 gap-4 sm:grid-cols-3" data-id="element-169" data-mp="3mukbb4dxuv2b">
            {conciergeModalities.map(modality => <div key={modality.name} className="rounded-2xl border border-white/15 bg-white/[0.07] p-4 transition-colors hover:border-teal/60 hover:bg-white/[0.1]" data-id="element-170" data-mp="1g5xlnczj0zor">
                <div className="mb-3 h-1 w-8 rounded-full bg-teal" data-id="element-171" data-mp="1iqdhxewnr9e6" />
                <p className="font-display text-[14px] font-bold leading-tight text-white" data-id="element-172" data-mp="1eme4542riooi">
                  {modality.name}
                </p>
                <p className="mt-1.5 text-[12px] leading-snug text-white/70" data-id="element-173" data-mp="19qgpd275dqdu">
                  {modality.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}